import React from 'react';
import { useCurrentRefinements } from 'react-instantsearch';
import { useEventListContext } from '../context/EventListProvider';
import { CurrentRefinementsConnectorParams } from 'instantsearch.js/es/connectors/current-refinements/connectCurrentRefinements';

const DialogToggle = (props: CurrentRefinementsConnectorParams) => {
  const { items } = useCurrentRefinements(props);
  const { showDialog, i18n } = useEventListContext();
  const count = items.reduce((prev, curr) => prev + curr.refinements.length, 0);

  return (
    <button
      className={`event-list__filter-toggle button button--${
        count > 0 ? 'primary' : 'secondary'
      }`}
      type="button"
      onClick={showDialog}
    >
      <svg
        width="240"
        height="240"
        viewBox="0 0 240 240"
        xmlns="http://www.w3.org/2000/svg"
        className="icon button__icon"
      >
        <path
          d="m190 40-60.001 94.287L130 200h-20l-.001-65.716L50 40h140Zm-36.434 20H86.433L120 112.747 153.566 60Z"
          fill="currentColor"
          fillRule="nonzero"
        />
      </svg>

      <span className="typo-button">
        {count > 0
          ? i18n.changeFilter.replace('{count}', `${count}`)
          : i18n.openFilter}
      </span>
    </button>
  );
};

export default DialogToggle;
